import React, { useState, useEffect } from "react";
import SmoothScrollLink from "../components/SmoothScrollLink";
import { useTranslation } from "react-i18next";
import "./Solutions.css";

function Solutions({ hideHero = false }) {
  const { t } = useTranslation();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const bgImage = process.env.PUBLIC_URL + "/assets/bg.jpg";
  const triaImage = process.env.PUBLIC_URL + "/assets/tria.jpg";

  const projectCards = [
    {
      key: "ifcClassify",
      image: "/assets/projectpics/ifcclassifier.jpeg",
      color: "#00e0ff",
    },
    {
      key: "ifcLCA",
      image: "/assets/projectpics/ifclca.jpg",
      color: "#ff3cac",
    },
    {
      key: "ifcFlow",
      image: "/assets/projectpics/ifcflow.jpeg",
      color: "#7eff00",
    },
    {
      key: "modelChecker",
      image: "/assets/projectpics/checker.jpg",
      color: "#ffb700",
    },
    {
      key: "lcaData",
      image: "/assets/projectpics/lcadata.jpg",
      color: "#a067ff",
    },
  ];

  // Check for dark mode on component mount and when it changes
  useEffect(() => {
    const checkDarkMode = () => {
      const isDark = document.body.classList.contains("dark-mode");
      setIsDarkMode(isDark);
    };

    // Initial check
    checkDarkMode();

    // Set up a MutationObserver to watch for class changes on the body
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          checkDarkMode();
        }
      });
    });

    observer.observe(document.body, { attributes: true });

    return () => {
      observer.disconnect();
    };
  }, []);



  return (
    <div>
      {!hideHero && (
        <div
          className="hero-content"
          style={{
            backgroundImage: `url(${bgImage})`,
            minHeight: "30vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            position: "relative",
            padding: "3rem 1rem",
          }}
        >
          <h2 className="text-4xl font-bold">
            <span className="gradient-text">
              {t("solutions.hero.innovation")}
            </span>{" "}
            <span className="blinking-text-1">{t("solutions.hero.for")}</span>{" "}
            <span className="gradient-text">
              {t("solutions.hero.sustainable")}
            </span>{" "}
            <span className="blinking-text-2">
              {t("solutions.hero.construction")}
            </span>
          </h2>
          <div className="mt-6">
            <button className="btn-primary mx-2">
              <SmoothScrollLink to="/contact" sectionId="contact">
                {t("solutions.getStarted")}
              </SmoothScrollLink>
            </button>
          </div>
        </div>
      )}

      <div className="solutions-container">
        <div className="solutions-description">
          <p>{t("solutions.description")}</p>
        </div>

        <div
          className="solutions-background-section"
          style={{
            backgroundImage: `url(${triaImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "50vh",
          }}
        >
          <div
            className="overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: isDarkMode
                ? "rgba(0, 0, 0, 0.6)"
                : "rgba(255, 255, 255, 0.85)",
            }}
          ></div>
          <div className="solutions-content-overlay">
            <div className="neon-grid">
              {projectCards.map((proj) => {
                const data = t(`solutions.projects.${proj.key}`, { returnObjects: true });
                return (
                  <div
                    key={proj.key}
                    className="neon-card"
                    style={{ "--neon-color": proj.color }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + proj.image}
                      alt={data.title}
                    />
                    <h3>{data.title}</h3>
                    <p>{data.description}</p>
                    <a
                      href={data.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="neon-card-link"
                    >
                      Visit Project
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Solutions;
